
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import FileUploadMetaFields from "../../components/FileUploadMetaFields";
import { todayIsoDate } from "../../utils/fileMetaDisplay";

const ConUpload = () => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState("");
  const [folders, setFolders] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState("");
  const [file, setFile] = useState(null);
  const [displayName, setDisplayName] = useState("");
  const [issueDate, setIssueDate] = useState(() => todayIsoDate());
  const [author, setAuthor] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  const project = JSON.parse(localStorage.getItem("selectedProject") || "null");
  const projectId = project ? project.id : null;

  useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (!role || !projectId) {
      navigate("/");
    } else {
      setUserRole(role);
      fetchFolders();
    }
  }, [navigate, projectId]);

  const fetchFolders = async () => {
    try {
      const response = await fetch(
        `/api/folders?module=construction&projectId=${projectId}`,
      );
      if (!response.ok) throw new Error("Failed to fetch folders");
      const data = await response.json();
      setFolders(data);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setMessage("");
    setError(null);

    if (!file || !selectedFolderId || !displayName.trim() || !issueDate) {
      setError("Please select a folder and file, and enter display name and issue date.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("folderId", selectedFolderId);
    formData.append("projectId", projectId);
    formData.append("display_name", displayName.trim());
    formData.append("issue_date", issueDate);
    formData.append("author", author);
    formData.append("user_id", localStorage.getItem("userId"));

    try {
      const response = await fetch("/api/upload/construction", {
        method: "POST",
        body: formData,
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Upload failed");
      }
      
      await response.json();
      setMessage("File uploaded successfully!");
      setFile(null);
      setDisplayName("");
      setIssueDate(todayIsoDate());
      setAuthor("");
    } catch (err) {
      console.error("Upload error:", err);
      setError(err.message || "Failed to upload files");
    }
  };

  return (
    <div className="flex h-screen">
      <Sidebar userRole={userRole} projectId={projectId} scenario="construction" />

      <div className="flex-1 p-6 bg-gray-50 text-[12px] ml-[60px]">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-[18px]">Upload Construction Files</h2>
          <img src="/images/gemterra-logo-20260112-t.png" alt="Gemterra" className="h-6" />
        </div>

        <form onSubmit={handleUpload} className="space-y-4 w-[480px]">
          <div>
            <label className="block mb-1 font-medium text-[12px]">Select Folder</label>
            <select
              value={selectedFolderId}
              onChange={(e) => setSelectedFolderId(e.target.value)}
              className="w-full border rounded px-3 py-1 text-[12px]"
            >
              <option value="">-- Select Folder --</option>
              {folders.map((folder) => (
                <option key={folder._id} value={folder._id}>
                  {folder.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block mb-1 font-medium text-[12px]">
              Select File (PDF, JPG, PNG)
            </label>
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => setFile(e.target.files[0])}
              className="w-full text-[12px]"
              required
            />
          </div>

          <FileUploadMetaFields
            displayName={displayName}
            onDisplayNameChange={setDisplayName}
            issueDate={issueDate}
            onIssueDateChange={setIssueDate}
            author={author}
            onAuthorChange={setAuthor}
            ids={{
              display: "con-page-upload-display",
              issue: "con-page-upload-issue",
              author: "con-page-upload-author",
            }}
          />

          <button
            type="submit"
            className="text-white px-3 py-1 rounded text-[12px]"
            style={{ backgroundColor: "#6FA944" }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#5C8E37")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#6FA944")}
          >
            Upload Files
          </button>

          {message && <p className="text-green-600 mt-2">{message}</p>}
          {error && <p className="text-red-600 mt-2">{error}</p>}
        </form>

        <div className="mt-6 w-[480px]">
          <button
            onClick={() => navigate("/construction_files_folder")}
            className="bg-gray-300 text-black px-3 py-1 rounded hover:bg-gray-400 text-[12px]"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConUpload;
